var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('grupos-arquivos-data-table',{attrs:{"items":_vm.items},on:{"rechargeTable":function($event){return _vm.getAllGruposArquivos()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }